import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const useTenderEvaluationTabVisibility = () => {
  const { user } = useSelector(state => state.Login);

  return useMemo(() => {
    const userRoles = user?.role?.split(',').map(r => r.trim()) || [];
    const hasKPI = userRoles.includes('KPI');
    const hasPPN = userRoles.includes('PPN');
    const onlyKPI = hasKPI && !hasPPN;
    const onlyPPN = !hasKPI && hasPPN;
    const showBoth = (hasKPI && hasPPN) || (!hasKPI && !hasPPN);
    const showProductHydro = onlyPPN || showBoth;
    const showHydroCondensate = onlyKPI || showBoth;
    const defaultTab = onlyKPI ? 'hydrocarbon-condensat' : 'product-hydro';

    const canViewProcurementTypeHeader = procurementTypeHeader => {
      const header = String(procurementTypeHeader);
      // Product Hydro list pages are open to every role, KPI-only included.
      if (header === '1') return true;
      if (header === '2') return showHydroCondensate;
      return true;
    };

    return {
      onlyKPI,
      onlyPPN,
      showProductHydro,
      showHydroCondensate,
      defaultTab,
      canViewProcurementTypeHeader,
    };
  }, [user?.role]);
};

export default useTenderEvaluationTabVisibility;
